import React from 'react';
import {Flex, Preloader} from '@genestack/ui';
import {useDocumentTagsQuery} from './requests/use-document-tags-query';
import {Tag} from './tag';

interface Props {
    documentAccession: string;
    tagsType: 'public' | 'private' | 'both';
    emptyComponent?: React.ReactNode;
    removableTags?: boolean;
}

export function TagsList({documentAccession, tagsType, emptyComponent, removableTags}: Props) {
    const documentTagsQuery = useDocumentTagsQuery(documentAccession);

    const {publicTags, privateTags} = documentTagsQuery.data || {publicTags: [], privateTags: []};

    const tags = React.useMemo(
        () => [
            ...(['public', 'both'].includes(tagsType)
                ? [...publicTags]
                      .sort((tag1, tag2) => (tag1 < tag2 ? -1 : 1))
                      .map((tag) => (
                          <Tag
                              key={tag}
                              tag={tag}
                              isPrivate={false}
                              accession={documentAccession}
                              removable={removableTags}
                          />
                      ))
                : []),
            ...(['private', 'both'].includes(tagsType)
                ? [...privateTags]
                      .sort((tag1, tag2) => (tag1 < tag2 ? -1 : 1))
                      .map((tag) => (
                          <Tag
                              key={tag}
                              tag={tag}
                              isPrivate
                              accession={documentAccession}
                              removable={removableTags}
                          />
                      ))
                : [])
        ],
        [publicTags, privateTags, documentAccession, tagsType, removableTags]
    );

    if (!documentTagsQuery.data) {
        return <Preloader show count={1} box="paragraph" />;
    }

    return (
        <Flex gap={3} flexWrap="wrap" container>
            <div>{tags.length ? tags : emptyComponent}</div>
        </Flex>
    );
}
